import React from 'react';

export default ({ className = '' }: { className?: string }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M53.1255 29.999C53.1255 17.2274 42.7721 6.87402 30.0005 6.87402C17.2289 6.87402 6.87549 17.2274 6.87549 29.999C6.87549 42.7706 17.2289 53.124 30.0005 53.124C42.7721 53.124 53.1255 42.7706 53.1255 29.999ZM39.9248 21.1733C40.657 20.4411 41.8439 20.4411 42.5762 21.1733C43.3084 21.9056 43.3084 23.0925 42.5762 23.8247L27.5762 38.8247C26.8439 39.5569 25.657 39.5569 24.9248 38.8247L17.4248 31.3247L17.2954 31.1831C16.6946 30.4466 16.7383 29.3598 17.4248 28.6733C18.1113 27.9868 19.1981 27.9432 19.9346 28.5439L20.0762 28.6733L26.2505 34.8477L39.9248 21.1733ZM56.8755 29.999C56.8755 44.8417 44.8431 56.874 30.0005 56.874C15.1578 56.874 3.12549 44.8417 3.12549 29.999C3.12549 15.1564 15.1578 3.12402 30.0005 3.12402C44.8431 3.12402 56.8755 15.1564 56.8755 29.999Z"
        fill="#079455"
      />
    </svg>
  );
};
